import { createWavemakerGame as createGame } from "./game/createWavemakerGame.js";
import type { Translate } from "./i18n";

export interface WavemakerOptions {
  canvas?: HTMLCanvasElement;
  canvasSelector?: string;
  locale?: string;
  translate?: Translate;
  onLevelLabelChange?(label: string): void;
  onTimeSpeedLabelChange?(label: string): void;
}

export interface WavemakerGameHandle {
  pause?(): void;
  resume?(): void;
  setShowReferenceLines?(enabled: boolean): void;
  setReferenceLineSpacingRatio?(spacingRatio: number): void;
  destroy?(): void;
  scope?: unknown;
}

export function createWavemakerGame(options: WavemakerOptions = {}): WavemakerGameHandle {
  return createGame(options);
}
